import {EndpointsFactory} from "@/utilities/endpoints";
import {DecodeResponseType, WorkerResponse} from "@/utilities/workerUtilites";

onmessage = worker_messageReceive;

function sendMessage(msg){
	postMessage(msg);
}

function worker_sendMessageToClient(client, msg){
	return sendMessage(msg, client);
}

async function worker_messageReceive({data: msg, source: client}){
	const url = msg.url;
	const token = msg.token;
	const contentType = msg.contentType;
	const method = msg.method;
	const responseCode = msg.responseCode;
	const body = msg.body;
	const formData = msg.formData;
	const decodeResponseType = msg.decodeResponseType ?? DecodeResponseType.JSON;
	try{
		let form;
		if(formData){
			form = new FormData();
			for(const key in formData){
				form.append(key, formData[key]);
			}
		}
		const fetchRes = await fetch(url, {
			headers: EndpointsFactory.fetchGlobalHeaders(token, contentType),
			method: method,
			body: form ? form : body
		});

		if(!fetchRes.ok){
			worker_sendMessageToClient(client, {
				code: responseCode,
				status: WorkerResponse.ERROR,
				http_code: fetchRes.status,
				response_type: fetchRes.headers.get('content-type'),
				response: await fetchRes.text()
			});
			return;
		}
		let res;
		switch (decodeResponseType){
			case DecodeResponseType.JSON:
				res = await fetchRes.json();
				break;
			case DecodeResponseType.TEXT:
				res = await fetchRes.text();
				break;
			case DecodeResponseType.BLOB:
				res = await fetchRes.blob();
				break;
			default:
				res = null;
		}

		worker_sendMessageToClient(client, {
			code: responseCode,
			status: WorkerResponse.SUCCESS,
			response: res,
			response_type: fetchRes.headers.get('content-type'),
			http_code: fetchRes.status
		});
	}catch (e){
		worker_sendMessageToClient(client, {
			code: responseCode,
			status: WorkerResponse.ERROR,
			response: e
		});
	}
}